import { API_BASE_URL } from '../api/config';

/**
 * Формирует полный URL для изображения товара
 * Если путь начинается с /uploads, добавляет базовый URL сервера
 * Если путь уже полный (http/https), возвращает как есть
 * Если путь пустой или undefined, возвращает fallback
 */
export function getProductImageUrl(imagePath?: string | null, fallback?: string): string {
  if (!imagePath) {
    return fallback || '';
  }

  // Если путь уже полный URL, возвращаем как есть
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Если путь начинается с /uploads, возвращаем как есть (nginx отдаёт статику напрямую)
  if (imagePath.startsWith('/uploads')) {
    return imagePath;
  }

  // Если путь не начинается с /, добавляем его
  if (!imagePath.startsWith('/')) {
    return `${API_BASE_URL}/uploads/${imagePath}`;
  }

  // В остальных случаях просто добавляем базовый URL
  return `${API_BASE_URL}${imagePath}`;
}

